<script setup lang="ts"></script>

<template>
  <figure class="flex items-center justify-between flex-wrap gap-2 h-fit">
    <div class="flex flex-col items-start max-w-[12rem] gap-1">
      <span class="text-justify">Transacciones realizadas con:</span>
      <img
        src="../../../assets/imgs/openpay/LogotipoOpenpay-01.jpg"
        alt="Logo de OpenPay"
      />
    </div>

    <div class="flex items-center max-w-[15rem] gap-2">
      <img src="@/assets/imgs/openpay/security.png" alt="Logo de escudo" />
      <span
        >Tus pagos se realizan de manera segura con encriptación de 256
        bits.</span
      >
    </div>
  </figure>
</template>

<style>
span {
  @apply text-xs font-medium;
}
</style>
